
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/foto-izbor/finalisti",
      function () {
        return require("private-next-pages/foto-izbor/finalisti/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/foto-izbor/finalisti"])
      });
    }
  